import { Card, Row, Tooltip, notification } from 'antd'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { CopyOutlined } from '@ant-design/icons';
import Heading from '../../../../component/common/Heading'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import { convertUTCToLocal } from '../../../../util/functions'
import BackButton from '../../../../component/common/Back-Button';

const FeederErrorLogs = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const copyHandler = (id) => {
        try {
            window.navigator.clipboard.writeText(id)
            notification.success({ message: 'Unique Id Copied' })

        } catch (error) {
            notification.error({ message: 'Something went wrong' })
        }
    }
    return (
        <>
            <div>
                <Card className="my-5">
                    <BackButton onClick={() => navigate(-1)} />
                    <Heading>Feeder Error Logs</Heading>
                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.Feeder_Error.getAll,
                                extraQuery: {
                                    feedarId: id
                                },
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `DE${data?.id.toString().padStart(7, "0")}`,
                                            timeStampD: data?.timeStamp ? convertUTCToLocal(data?.timeStamp, 'DD MMM, YYYY hh:mm A') : '',
                                            uniqueIdD: <div> {data?.feedar?.uniqueId} <Tooltip title="Copy Unique Id"> <CopyOutlined onClick={() => {
                                                copyHandler(data?.feedar?.uniqueId)
                                            }} /></Tooltip> </div> || '-',


                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.DEVICE_ERROR_LOG,
                            }}
                            isSearch
                        />
                    </Row>
                </Card>
            </div>
        </>
    )
}

export default FeederErrorLogs